import { render, staticRenderFns } from "./Responsibilities.vue?vue&type=template&id=ec91defc&lang=pug"
import script from "./Responsibilities.vue?vue&type=script&lang=js"
export * from "./Responsibilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports